import { type FC, memo } from 'react';
import type { BonanzaPromoDataApi } from '@/api/cms';
import { ReceiveBonusesNotice } from '@/modules/common/components/ReceiveBonusesNotice';
import { useBonanzaPromo } from '@/modules/promotions/hooks';
import { TextContentByGroup } from '@/modules/restrictions/components/TextContentByGroup';
import { ScHeading } from './styled';

type HeadingProps = Pick<
  BonanzaPromoDataApi,
  | 'titleImg'
  | 'title'
  | 'description'
  | 'pageTitle'
  | 'congratulations'
  | 'enjoyYourPlay'
>;

export const Heading: FC<HeadingProps> = memo(
  ({ title, description, pageTitle, congratulations, enjoyYourPlay }) => {
    const { promoBonus, isBonusIssued } = useBonanzaPromo();

    return (
      <ScHeading>
        <div className="bonuses-notice-box">
          <ReceiveBonusesNotice
            successMessage="canIssueBonuses.success"
            translation="promotions"
            warningMessage="canIssueBonuses.warning"
          />
        </div>
        <div className="page-title">{pageTitle}</div>
        <div className="textContainer">
          {isBonusIssued && promoBonus ? (
            <>
              <div className="title issued">{congratulations}</div>
              <div className="authDescription issued">
                {enjoyYourPlay.replace('{{amount}}', promoBonus.amount)}
              </div>
            </>
          ) : (
            <>
              <TextContentByGroup className="title" sections={title} />
              <TextContentByGroup
                className="authDescription"
                sections={description}
              />
            </>
          )}
        </div>
      </ScHeading>
    );
  }
);
